module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "data-lists"
    }
  }, [(_vm.isLoading) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "breadcrumbs"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_vm._v("Datos Abiertos")]), _vm._v("\n      / " + _vm._s(_vm.pageTitle) + "\n    ")], 1), _vm._v(" "), (_vm.files.length == 0) ? _c('div', {
    staticClass: "no-results"
  }, [_vm._v("\n      Lo sentimos no encontramos ningún resultado con este criterio.\n    ")]) : _vm._e(), _vm._v(" "), (_vm.files.length > 0) ? _c('div', {
    staticClass: "table table-condensed table-striped table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.files), function(file) {
    return _c('filerow', {
      key: file.permalink,
      attrs: {
        "title": file.title,
        "link": file.permalink,
        "modified": file.modified,
        "term": file.topics[0].title,
        "area": file.areas[0].title
      }
    })
  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pagination-holder"
    }
  }, [(_vm.numpages > 1) ? _c('paginate', {
    attrs: {
      "page-count": _vm.numpages,
      "prev-text": 'Anterior',
      "next-text": 'Siguente',
      "container-class": 'pagination justify-content-center',
      "page-link-class": 'page-link',
      "prev-link-class": 'page-link',
      "next-link-class": 'page-link',
      "page-class": 'page-item',
      "prev-class": 'page-item',
      "next-class": 'page-item',
      "initial-page": _vm.page,
      "click-handler": _vm.doNavigation
    }
  }) : _vm._e()], 1)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Descripción")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Tema")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("Área")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2d71c36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lists.vue
// module id = 60
// module chunks = 1